import { useRef, useState } from "react";
import PropTypes from "prop-types";
import { Modal, Button, Carousel, Row, Col } from "antd";

import "./OnboardMessagesModal.css";
import { useExceptionHandler } from "../../hooks/useExceptionHandler.jsx";
import { useAlertStore } from "../../store/alert-store";
import { useAxiosPrivate } from "../../hooks/useAxiosPrivate";
import { useSessionStore } from "../../store/session-store";

function OnboardMessagesModal({ open, setOpen, slides }) {
  const carouselRef = useRef();
  const [currentSlide, setCurrentSlide] = useState(0);
  const axiosPrivate = useAxiosPrivate();
  const { sessionDetails, updateSessionDetails } = useSessionStore();
  const { loginOnboardingMessage, promptOnboardingMessage } = sessionDetails;
  const { setAlertDetails } = useAlertStore();
  const handleException = useExceptionHandler();

  const next = () => {
    carouselRef.current.next();
    setCurrentSlide(currentSlide + 1);
  };

  const prev = () => {
    if (currentSlide > 0) {
      carouselRef.current.prev();
      setCurrentSlide(currentSlide - 1);
    }
  };

  const handleFinishClick = () => {
    setOpen(false);
    const data = {
      is_login_onboarding_msg: false,
      is_prompt_studio_onboarding_msg: false,
    };
    if (!loginOnboardingMessage) {
      data.is_login_onboarding_msg = true;
    } else if (!promptOnboardingMessage) {
      data.is_login_onboarding_msg = true;
      data.is_prompt_studio_onboarding_msg = true;
    }
    const requestOptions = {
      method: "PUT",
      url: `/api/v1/unstract/${sessionDetails?.orgId}/users/profile/`,
      headers: {
        "X-CSRFToken": sessionDetails?.csrfToken,
        "Content-Type": "application/json",
      },
      data,
    };
    axiosPrivate(requestOptions)
      .then(() => {
        const onboardMessagesInSession = {
          loginOnboardingMessage: data.is_login_onboarding_msg,
          promptOnboardingMessage: data.is_prompt_studio_onboarding_msg,
        };
        updateSessionDetails(onboardMessagesInSession);
      })
      .catch((err) => {
        setAlertDetails(handleException(err));
      });
  };

  return (
    <Modal
      open={open}
      onCancel={() => setOpen(false)}
      maskClosable={false}
      width={1000}
      height="auto"
      centered
      footer={null}
      closable={false}
    >
      <Carousel ref={carouselRef} dots={true} afterChange={setCurrentSlide}>
        {slides.map((slide, index) => (
          <div key={index} className="onboard-modal">
            <Row gutter={16} align="middle">
              <Col span={12}>
                <div>
                  <img src={slide.image} alt={`slide-${index}`} />
                </div>
              </Col>
              <Col span={12} className="right-col">
                <div>
                  <img src={slide.imageIcon} />
                  <h2>{slide.title}</h2>
                  <div>{slide.text}</div>
                </div>
                <div className="button-group">
                  {currentSlide !== 0 && (
                    <Button key="prev" onClick={prev}>
                      Previous
                    </Button>
                  )}
                  {currentSlide !== slides.length - 1 ? (
                    <Button
                      className="next-btn"
                      key="next"
                      type="primary"
                      onClick={next}
                    >
                      Next
                    </Button>
                  ) : (
                    <Button
                      key="finish"
                      type="primary"
                      onClick={handleFinishClick}
                    >
                      Finish
                    </Button>
                  )}
                </div>
              </Col>
            </Row>
          </div>
        ))}
      </Carousel>
    </Modal>
  );
}

OnboardMessagesModal.propTypes = {
  open: PropTypes.bool.isRequired,
  setOpen: PropTypes.func.isRequired,
  slides: PropTypes.array.isRequired,
};

export { OnboardMessagesModal };
